export const COVERAGE_CONFIGURATION_TYPE_MANUAL = 1;
export const COVERAGE_CONFIGURATION_TYPE_AUTOMATIC = 2;
